import React, { useEffect, useState } from "react";
import customMenuService from "../../../services/customMenuService.js";

const ModalCustomMenu = ({ editingModal, titleSingular, isModalOpen, onClose }) => {
    const [titulo, setTitulo] = useState("");
    const [url, setUrl] = useState("");
    const [ubicacion, setUbicacion] = useState("");
    const [icono, setIcono] = useState("");

    const [ubicacionList] = useState([
        "/",
        "/Home/",
        "/Proyectos/",
        "/Parámetros/"
    ]);

    const iconOptions = [
        "bi-alarm", "bi-alexa", "bi-align-bottom", "bi-align-center", "bi-align-end",
        "bi-align-middle", "bi-align-start", "bi-align-top", "bi-alt", "bi-android",
        "bi-app", "bi-archive", "bi-arrow-90deg-down", "bi-arrow-90deg-left", "bi-arrow-90deg-right",
        "bi-arrow-90deg-up", "bi-arrow-bar-down", "bi-arrow-bar-left", "bi-arrow-bar-right", "bi-arrow-bar-up",
        "bi-arrow-clockwise", "bi-arrow-counterclockwise", "bi-arrow-down", "bi-arrow-down-circle", "bi-arrow-down-left-circle",
        "bi-arrow-down-right-circle", "bi-arrow-left", "bi-arrow-left-circle", "bi-arrow-repeat", "bi-arrow-return-left",
        "bi-arrow-return-right", "bi-arrow-right", "bi-arrow-right-circle", "bi-arrow-up", "bi-arrow-up-circle",
        "bi-arrow-up-left-circle", "bi-arrow-up-right-circle", "bi-arrows-angle-contract", "bi-arrows-angle-expand", "bi-arrows-collapse",
        "bi-arrows-expand", "bi-arrows-fullscreen", "bi-arrows-move", "bi-aspect-ratio", "bi-asterisk",
        "bi-at", "bi-award", "bi-back", "bi-backspace", "bi-bag",
        "bi-bank", "bi-bar-chart", "bi-bar-chart-line", "bi-basket", "bi-battery",
        "bi-bell", "bi-bezier", "bi-bicycle", "bi-binoculars", "bi-blockquote-left",
        "bi-blockquote-right", "bi-bluetooth", "bi-book", "bi-bookmark", "bi-bootstrap",
        "bi-box", "bi-box-arrow-down", "bi-box-arrow-in-down", "bi-box-arrow-in-left", "bi-box-arrow-in-right",
        "bi-box-arrow-in-up", "bi-box-arrow-left", "bi-box-arrow-right", "bi-box-arrow-up", "bi-braces",
        "bi-bricks", "bi-briefcase", "bi-brightness-alt-high", "bi-brightness-alt-low", "bi-brightness-high",
        "bi-brightness-low", "bi-broadcast", "bi-brush", "bi-bucket", "bi-bug",
        "bi-building", "bi-bullseye", "bi-calendar", "bi-camera", "bi-capslock",
        "bi-card-checklist", "bi-card-heading", "bi-card-image", "bi-card-list", "bi-card-text",
        "bi-caret-down", "bi-caret-left", "bi-caret-right", "bi-caret-up", "bi-cart",
        "bi-cash", "bi-cast", "bi-chat", "bi-check", "bi-check-all",
        "bi-chevron-bar-contract", "bi-chevron-bar-down", "bi-chevron-bar-expand", "bi-chevron-bar-left", "bi-chevron-bar-right",
        "bi-chevron-bar-up", "bi-chevron-compact-down", "bi-chevron-compact-left", "bi-chevron-compact-right", "bi-chevron-compact-up",
        "bi-chevron-contract", "bi-chevron-double-down", "bi-chevron-double-left", "bi-chevron-double-right", "bi-chevron-double-up",
        "bi-chevron-down", "bi-chevron-expand", "bi-chevron-left", "bi-chevron-right", "bi-chevron-up",
        "bi-circle", "bi-clipboard", "bi-clock", "bi-cloud", "bi-code",
        "bi-collection", "bi-compass", "bi-cone", "bi-controller", "bi-cpu",
        "bi-credit-card", "bi-crop", "bi-crosshair", "bi-cursor", "bi-dash",
        "bi-database", "bi-device-hdd", "bi-device-ssd", "bi-diagram-3", "bi-display",
        "bi-download", "bi-droplet", "bi-ear", "bi-easel", "bi-egg",
        "bi-envelope", "bi-exclamation", "bi-eye", "bi-eye-slash", "bi-facebook",
        "bi-fast-forward", "bi-file", "bi-filter", "bi-flag", "bi-flower",
        "bi-folder", "bi-gear", "bi-gem", "bi-geo", "bi-gift",
        "bi-globe", "bi-graph-down", "bi-graph-up", "bi-grid", "bi-hammer",
        "bi-hand-index", "bi-hand-thumbs-up", "bi-hash", "bi-headphones", "bi-heart",
        "bi-house", "bi-image", "bi-inbox", "bi-info", "bi-instagram",
        "bi-joystick", "bi-journal", "bi-key", "bi-laptop", "bi-lightbulb",
        "bi-link", "bi-list", "bi-lock", "bi-magic", "bi-map",
        "bi-megaphone", "bi-mic", "bi-moon", "bi-mouse", "bi-music-note",
        "bi-newspaper", "bi-node-plus", "bi-palette", "bi-paperclip", "bi-pause",
        "bi-pen", "bi-pencil", "bi-person", "bi-phone", "bi-pin",
        "bi-play", "bi-plug", "bi-plus", "bi-power", "bi-printer",
        "bi-question", "bi-radioactive", "bi-record", "bi-reddit", "bi-reply",
        "bi-rewind", "bi-rocket", "bi-save", "bi-scissors", "bi-search",
        "bi-share", "bi-shield", "bi-shop", "bi-signpost", "bi-skip-forward",
        "bi-slack", "bi-sliders", "bi-smartwatch", "bi-speaker", "bi-star",
        "bi-stop", "bi-suit-heart", "bi-sun", "bi-table", "bi-tag",
        "bi-terminal", "bi-textarea", "bi-thermometer", "bi-three-dots", "bi-ticket",
        "bi-toggle-on", "bi-tools", "bi-trash", "bi-trophy", "bi-truck",
        "bi-tv", "bi-twitter", "bi-type", "bi-unlock", "bi-upload",
        "bi-usb", "bi-vector-pen", "bi-video", "bi-volume-down", "bi-volume-up",
        "bi-wallet", "bi-wifi", "bi-windows", "bi-wrench", "bi-x",
        "bi-youtube", "bi-zoom-in", "bi-zoom-out"
    ];

    useEffect(() => {
        if (editingModal) {
            setTitulo(editingModal.name || "");
            setUrl(editingModal.url || "");
            setUbicacion(editingModal.location || "");
            setIcono(editingModal.icon || "");
        } else {
            setTitulo("");
            setUrl("");
            setUbicacion("");
            setIcono("");
        }
    }, [editingModal]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            id: editingModal?.id || null,
            name: titulo,
            url,
            location: ubicacion,
            icon: icono
        };
        console.log(payload);

        customMenuService.saveOrUpdateCustomMenu(payload).then(onClose);

        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>×</button>
                <h2>{editingModal ? `Editar ${titleSingular}` : `Crear ${titleSingular}`}</h2>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="titulo">Título</label>
                        <input
                            type="text"
                            id="titulo"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="url">URL</label>
                        <input
                            type="text"
                            id="url"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="ubicacion">Ubicación</label>
                        <select
                            id="ubicacion"
                            value={ubicacion}
                            onChange={(e) => setUbicacion(e.target.value)}
                            required
                        >
                            <option value="">Selecciona una ubicación</option>
                            {ubicacionList.map((ruta, index) => (
                                <option key={index} value={ruta}>
                                    {ruta}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Ícono
                            {icono && (
                                <span>: <i className={`bi ${icono}`} style={{ fontSize: "1.2rem" }}></i> {icono}</span>
                            )}
                        </label>
                        <div className="icon-grid">
                            {iconOptions.map((iconClass) => (
                                <div
                                    key={iconClass}
                                    className={`icon-item ${icono === iconClass ? "selected" : ""}`}
                                    onClick={() => setIcono(iconClass)}
                                >
                                    <i className={`bi ${iconClass}`} style={{ fontSize: "1.2rem" }}></i>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="submit" className="btn btn-primary">Guardar</button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalCustomMenu;
